import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import axios from 'axios/index';
import {
    createDateTimeObject,
    generateUUID
} from '../shared/functions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import {RESOURCES as inventoryResources} from '../fuseInventoryResourceMap';
import Config from '../messages';
import FuseTheme from '../global/theme';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import Snackbar from 'material-ui/Snackbar';
import CircularProgress from 'material-ui/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import ContentCheck from 'material-ui/svg-icons/action/check-circle';

/**
 * A component for displaying and processing a Receive Transfer.
 *
 */
class TransferReceive extends Component {
    constructor(props) {
        super(props);

        this.state = {
            disableButton: false,
            record: {},
            notificationMessage: '',
            notificationOpen: false,
            showSuccessMessage: null,
            submitting: false,
        };

        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.activateComponent = this.activateComponent.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.record !== this.props.record) {
            this.setState({
                record: nextProps.record
            });
        }
    }

    // Handle click event to receive Transfer
    handleButtonClick = (e) => {
        this.props.onClickReceive('clicked receive');
        this.activateComponent(true);
        this.setState({
            disableButton: true,
            submitting: true
        });
        this.sendData();
    };

    // Send event to toggle other component
    activateComponent = (activate) => {
        this.props.onActivateComponent(activate);
    };

    // Post a request to receive this Transfer for the current Location
    sendData() {

        // Create a client Udt for this Location
        const clientUdt = {
            system: localStorage.getItem('system'),
            location: this.props.record.location_to,
            register: Config.fuse.client.register,
            user: localStorage.getItem('email'),
            device: Config.fuse.client.device,
            version: Config.fuse.admin.version
        };

        // Assemble a model
        let payload = {
            "client": {
                system: localStorage.getItem('system'),
                location: Config.fuse.client.location,
                register: Config.fuse.client.register,
                user: localStorage.getItem('email'),
                device: Config.fuse.client.device,
                version: Config.fuse.admin.version
            },
            "payload": {
                "model": {
                    client: clientUdt,
                    mode: localStorage.getItem('mode'),
                    transferSeq: this.props.record.transfer_id
                }
            },
            "pkg_date_time": createDateTimeObject(),
            "pkg_uuid": generateUUID(),
            "pkg_version": 4,
        };

        // Assemble the URI
        const resource = inventoryResources.TransferReceive.UPDATE();

        // Post the data
        import ('../shared/serverFunctions').then(functions => {
            const tokenStatus = checkTokenStatus(null);
            if (tokenStatus.expired) {
                return;
            }
            axios({
                method: 'post',
                url: resource.uri,
                data: payload,
                headers: functions.getPostHeaders()
            }).then((result) => {
                if (result.data.payload) {
                    this.setState({
                        notificationMessage: 'Successfully received this Transfer.',
                        notificationOpen: true,
                        showSuccessMessage: true,
                        submitting: false
                    });
                }
            }).catch((error) => {
                if (error.response) {
                    // Server response outside 2xx
                    console.log(error.response.data);
                } else if (error.request) {
                    // No response
                    console.log(error.request);
                } else {
                    console.log('Error', error.message);
                }
                this.setState({
                    disableButton: false,
                    notificationOpen: false,
                    submitting: false
                });
                this.activateComponent(false);
            });
        });
    }

    render() {
        const {
            position,
            record,
            showComponent
        } = this.props;

        const styles = {
            buttonCard: {
                flex: '0 1 50%',
                display: 'inline-block',
                width: 'calc(50% - 0.5em)',
                margin: '1em 1em 1em 0',
                verticalAlign: 'top',
            },
            buttonCardLast: {
                marginRight: 0,
            },
            cardText: {
                display: 'block',
                width: '100%',
                fontSize: '14px',
                color: FuseTheme.palette.lightTextColor,
                margin: '0 0 1em 0',
            },
            cardTextBelow: {marginTop: '1em'},
            loader: {
                display: 'inline-block',
                margin: '0 0 0 8px',
                verticalAlign: 'middle',
            },
        };
        const cardStyle = (position === 'right') ? {...styles.buttonCard, ...styles.buttonCardLast} : styles.buttonCard;

        return (
            <Card className="buttonCard" style={cardStyle}>
                <CardHeader title="Receive Transfer"/>
                <CardText>
                    {/* Receive Transfer button */}
                    <span style={styles.cardText}>
                        Click <strong>Receive Transfer</strong> to receive the contents of this Transfer to this
                        Location ({record.location_to}).
                    </span>
                    <RaisedButton
                        primary
                        label="Receive Transfer"
                        icon={<ContentCheck/>}
                        onClick={(e) => this.handleButtonClick(e)}
                        disabled={!showComponent || this.state.disableButton}
                    />
                    {this.state.submitting &&
                    <CircularProgress
                        size={20}
                        thickness={2}
                        style={styles.loader}
                    />
                    }

                    {/* Success messaging and List link */}
                    {this.state.showSuccessMessage &&
                    <div>
                        <span style={{...styles.cardText, ...styles.cardTextBelow}}>
                            This Transfer has been received.
                        </span>
                        <FlatButton
                            primary
                            label="View Incoming Transfers"
                            containerElement={<Link to="/InventoryTransfers"/>}
                        />
                        <FlatButton
                            primary
                            label="View Received Transfers"
                            containerElement={<Link to="/ReceivedInventoryTransfers"/>}
                        />
                    </div>
                    }
                    <Snackbar
                        open={this.state.notificationOpen}
                        message={this.state.notificationMessage}
                        autoHideDuration={3000}
                        bodyStyle={styles.notification}
                    />
                </CardText>
            </Card>
        )
    }
}

TransferReceive.propTypes = {
    addField: PropTypes.bool,
    basePath: PropTypes.string.isRequired,
    record: PropTypes.object,
    onActivateComponent: PropTypes.func,
    onClickReceive: PropTypes.func,
    position: PropTypes.string,
    showComponent: PropTypes.bool,
};

TransferReceive.defaultProps = {
    addField: true,
    position: 'left',
    showComponent: true,
};

export default TransferReceive;



// WEBPACK FOOTER //
// ./src/Fuse/components/TransferReceive.js